import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material';
import Input, { CustomInputProps } from '../input';

export interface EmailInputProps extends CustomInputProps {
  submitReady: (inputState: boolean) => void;
  updateEmail: (inputVal: string) => void;
}

const CustomInput = styled(Input)`
  margin-bottom: 10px;
`;

const EmailInput: React.FC<EmailInputProps> = ({
  submitReady,
  updateEmail,
}) => {
  const [email, setEmail] = useState('');
  const [errText, setErrText] = useState('');
  const [emailErr, setEmailErr] = useState(false);
  // Javascript version of RFC 5322's regex
  const emailValidation =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const errDialogue = 'The email address entered is invalid.';

  const validateEmail = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setEmail(event.target.value);
    if (emailValidation.test(event.target.value) === false) {
      setEmailErr(true);
      setErrText(errDialogue);
    } else {
      setEmailErr(false);
      setErrText('');
    }

    // pass value of input field outwardly to notifyMe Modal
    updateEmail(event.target.value);
  };

  useEffect(() => {
    // check if it is ready to be submitted
    if (!emailErr && email.length > 0) {
      submitReady(false);
    } else {
      submitReady(true);
    }
  }, [emailErr, email]);

  return (
    <CustomInput
      label="Email address"
      showEndAdornments={false}
      labelColor="#929499"
      helperText={errText}
      onChange={(event) => validateEmail(event)}
      error={emailErr}
    />
  );
};

export default EmailInput;
